import { render, staticRenderFns } from "./cardEditBase.vue?vue&type=template&id=da06d22e&scoped=true&"
import script from "./cardEditBase.vue?vue&type=script&lang=js&"
export * from "./cardEditBase.vue?vue&type=script&lang=js&"
import style0 from "./cardEditBase.vue?vue&type=style&index=0&id=da06d22e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da06d22e",
  null
  
)

export default component.exports